import { render, staticRenderFns } from "./MenuDraggableComponent.vue?vue&type=template&id=6e1b32ad&scoped=true&"
import script from "./MenuDraggableComponent.vue?vue&type=script&lang=js&"
export * from "./MenuDraggableComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuDraggableComponent.vue?vue&type=style&index=0&id=6e1b32ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b32ad",
  null
  
)

export default component.exports